import { render, staticRenderFns } from "./LclList.vue?vue&type=template&id=47d93ec1&scoped=true"
import script from "./LclList.vue?vue&type=script&lang=js"
export * from "./LclList.vue?vue&type=script&lang=js"
import style0 from "./LclList.vue?vue&type=style&index=0&id=47d93ec1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d93ec1",
  null
  
)

export default component.exports